import { render, staticRenderFns } from "./List.vue?vue&type=template&id=36ca162e"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PromotionProductCard: require('/opt/build/repo/components/promotion/ProductCard.vue').default,PromotionExtendedCard: require('/opt/build/repo/components/promotion/ExtendedCard.vue').default,ProductCarousel: require('/opt/build/repo/components/product/Carousel.vue').default})
